import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { convenience } from './convenience'
import { depot } from './depot'
import { goods } from './goods'
import { shoppingCar } from './shopping-car'
import { header } from './header'
import { payment } from './payment'
import { book } from './book'
export default (history: any) =>
  combineReducers({
    router: connectRouter(history),
    depot,
    goods,
    shoppingCar,
    header,
    payment,
    book,
    convenience,
  })
